export default __webpack_public_path__ + "static/media/Settings.5a41e3bb.svg";